import { Link } from "@tanstack/react-router";

/** Book-page byline: the author name links to the single author page. */
export function AuthorByline() {
  return (
    <p className="mt-4 text-sm text-ink/70">
      Yazar:{" "}
      <Link to="/yazar" className="text-ink underline decoration-ink/30 underline-offset-4 hover:decoration-ink">
        Arda Öztaşkın
      </Link>
    </p>
  );
}
